import Error from 'components/alerts/Error';
import { ContentLoader } from 'components/common/loader/ContentLoader';
import React from 'react';
import { Input, Label } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
// import { fetchGraphQL } from 'services/graphql/GraphQL';


export default class DecayCenter extends React.Component<
    {
        [label: string]: any;
    },
    {
        [label: string]: any;
    }
    > {

    public state = {
        isLoading: false,
        checkBoxOptions: {

        },
        ticketBank: [{
            name: '',
            promoter: '',
            price: '',
            activated: '',
            _id: ''
        }]
    }
    constructor(props) {

        super(props);
        this.decay = this.decay.bind(this)

    }

    public componentDidMount() {


        const ticketInventory = this.props.ticketInventory;
        ticketInventory.forEach((item) => {
            if (item.promoterId !== undefined && item.promoterId !== null) {
                if (this.props.promMap[item.promoterId] !== undefined) {
                    item.promoter = this.props.promMap[item.promoterId].name;
                }
            }
        })



        const privateTickets = ticketInventory.filter((item) => {
            return (item.promoter !== null && item.promoter !== undefined && Number(item.activated) !== 0)
        })
        const checkBoxOptions = {

        }
        privateTickets.forEach(element => {
            checkBoxOptions[element._id] = false;
        });

        this.setState({ ticketBank: privateTickets, checkBoxOptions })

    }

    public decay() {


        const arr: string[] = []

        Object.keys(this.state.checkBoxOptions).map(key => {
            if (this.state.checkBoxOptions[key] === true) {
                arr.push(key)
            }
        })

        if (arr.length > 0) {
            fetchGraphQL(
                `
            mutation {
                ticket {
                    decayAllSingle(eventId:"${this.props.eventId}", ticketBankIds:"${arr}")
                }
            }
            `
            ).then(res => {
                console.log('')
            })
        }

        this.props.onClose();
    }

    public render() {

        if (this.state.ticketBank === undefined || this.state.ticketBank === null || this.state.ticketBank.length === 0) {
            return <Error content="No tickets voidable" />
        } else {

            const content = this.state.ticketBank.map(item => {
                return <div key={item._id}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Input
                        type="checkbox"
                        checked={this.state.checkBoxOptions[item._id]}
                        onChange={e => {

                            this.setState({
                                checkBoxOptions: {
                                    ...this.state.checkBoxOptions,
                                    [item._id]: e.target.checked
                                }
                            })

                        }}
                        style={{ height: 'auto' }}
                    />
                    <p style={{ fontSize: '14px' }}>
                        <Label className="sexyBlack">
                            <b>{item.name}</b>
                        </Label><br />
                        <Label>
                            Promoter name: <b>{item.promoter}</b>
                        </Label><br />
                        <Label>
                            Price: <b>{(Number(item.price) / 100).toFixed(2)}</b>
                        </Label><br />
                    </p>
                    <br />
                </div>
            })

            return (
                <ContentLoader isLoading={this.state.isLoading}>

                    <div>
                        <p style={{ fontSize: '13px' }}>
                            Select which types of ticket offers to void. Hybrid offers of two or more different tickets will not be voided.
                            </p>
                        <br /><br />
                    </div>
                    {content}

                    <div className="Seperate-Buttons" style={{ paddingBottom: '15px' }}>

                        <button
                            className="new-button-white-3"
                            onClick={this.props.onClose}
                            style={{ border: 'none' }}
                        >
                            CANCEL
                        </button>


                        {this.state.ticketBank.length === 0 ? null : (
                            <button
                                className="new-button-white-3"
                                onClick={this.decay}
                                style={{ border: 'none' }}
                            >
                                VOID TICKETS
                            </button>
                        )}
                    </div>
                </ContentLoader>
            );
        }

    }

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/DecayCenter.tsx